import React from 'react';

export default function Header({ activeUser, onUserChange }) {
  return (
    <>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: '#e9ecef',
        padding: '10px 16px',
        borderRadius: '6px',
        marginBottom: '1.2rem',
        border: '1px solid #ced4da'
      }}>
        <div>
          <strong>Active Workstation Session: </strong>
          <span style={{ color: activeUser === 'officer1' ? '#0056b3' : '#6f42c1', fontWeight: 'bold' }}>
            {activeUser === 'officer1' ? 'Officer 1 (Authorized Issuer)' : 'Officer 2 (Joint Controller / Audit)'}
          </span>
        </div>
        <select
          value={activeUser}
          onChange={e => onUserChange(e.target.value)}
          style={{ padding: '6px 12px', borderRadius: '4px', border: '1px solid #adb5bd', fontWeight: 'bold' }}
        >
          <option value="officer1">Switch to Officer 1 (Authorized Issuer)</option>
          <option value="officer2">Switch to Officer 2 (Audit / Controller)</option>
        </select>
      </div>

      <h1 style={{ borderBottom: '2px solid #0056b3', paddingBottom: '0.5rem', color: '#0056b3', margin: 0 }}>
        Fabric PDF Content Verification System
      </h1>
      <p style={{ color: '#555', fontSize: '0.95rem', marginTop: '6px', marginBottom: '1.5rem' }}>
        Enterprise credential anchoring using RFC 8785 canonical dual-layer hashing over Hyperledger Fabric 2.5.
      </p>
    </>
  );
}